import { map as _map } from 'lodash-es';
import { useState, useCallback, Fragment } from 'react';
import { makeStyles } from 'tss-react/mui';
import Chip from '@mui/material/Chip';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const useStyles = makeStyles()((theme) => ({
  typeChip: {
    '& > span:first-of-type': {
      display: 'flex',
      alignItems: 'center',
      paddingRight: theme.spacing(0.5),
    },
  },
}));

type Props = {
  value?: string;
  attribute: string;
  onChange: (...args: unknown[]) => void;
  options: Record<string, string>;
};

const CalendarDropdownFilter = ({ attribute, options, value, onChange }: Props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { classes } = useStyles();

  const handleOpen = useCallback((e) => setAnchorEl(e.currentTarget), []);
  const handleClose = useCallback(() => setAnchorEl(null), []);
  const handleItemClick = useCallback((newValue) => {
    onChange(attribute, newValue);
    handleClose();
  }, [attribute, onChange, handleClose]);
  const active = value !== Object.keys(options)[0];

  return (
    <Fragment>
      <Chip
        aria-controls={`${attribute}-filter`}
        aria-haspopup="true"
        onClick={handleOpen}
        className={classes.typeChip}
        label={(
          <Fragment>
            {options[value]}
            {' '}
            <ArrowDropDownIcon />
          </Fragment>
        )}
        variant="outlined"
        clickable
        color={active ? 'primary' : 'default'}
      />
      <Menu
        id={`${attribute}-filter`}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {_map(options, (value, key) => (
          <MenuItem key={key} value={key} onClick={() => handleItemClick(key)}>
            {value}
          </MenuItem>
        ))}
      </Menu>
    </Fragment>
  );
};

export default CalendarDropdownFilter;
